/**
 * API Request Schemas
 * Validation schemas for API request parameters
 */

import { z } from 'zod';
import { paginationSchema } from '../common.schemas';
import { createTodoSchema, updateTodoSchema, todoFilterSchema, completeTodoSchema } from '../todo.schemas';
import { createClientSchema, updateClientSchema, clientFilterSchema } from '../client.schemas';
import { createProjectSchema, updateProjectSchema, projectFilterSchema } from '../project.schemas';

/**
 * Generic Request Schema
 * Base structure for API requests
 */
export const apiRequestSchema = z.object({
  body: z.unknown().optional(),
  query: z.record(z.unknown()).optional(),
  params: z.record(z.string()).optional(),
  headers: z.record(z.string()).optional(),
});

/**
 * Todo Request Schemas
 */
export const createTodoRequestSchema = z.object({
  body: createTodoSchema,
});

export const updateTodoRequestSchema = z.object({
  body: updateTodoSchema,
});

export const completeTodoRequestSchema = z.object({
  body: completeTodoSchema,
});

export const listTodosRequestSchema = z.object({
  query: todoFilterSchema.merge(paginationSchema),
});

export const getTodoRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});

export const deleteTodoRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});

/**
 * Client Request Schemas
 */
export const createClientRequestSchema = z.object({
  body: createClientSchema,
});

export const updateClientRequestSchema = z.object({
  body: updateClientSchema,
});

export const listClientsRequestSchema = z.object({
  query: clientFilterSchema.merge(paginationSchema),
});

export const getClientRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});

export const deleteClientRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});

/**
 * Project Request Schemas
 */
export const createProjectRequestSchema = z.object({
  body: createProjectSchema,
});

export const updateProjectRequestSchema = z.object({
  body: updateProjectSchema,
});

export const listProjectsRequestSchema = z.object({
  query: projectFilterSchema.merge(paginationSchema),
});

export const getProjectRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});

export const deleteProjectRequestSchema = z.object({
  params: z.object({
    id: z.string().uuid(),
  }),
});
